import { Pipe, PipeTransform } from '@angular/core';


@Pipe({
    name: 'listFilter',
    pure: false
})
export class ListFilterPipe implements PipeTransform {
 
 transform(items: any[], filter: any,  keyToSearch:string): any[] {
        if (!items || !filter) {
            return items;
        }
        // filter items array, items which match and return true will be kept, false will be filtered out
        return items.filter((item: any) => this.applyFilter(item, filter, keyToSearch));
    }
    
    /**
     * Perform the filtering.
     * 

     */
    applyFilter(item: any, filter: any, keyToSearch:string): boolean {
        //return !(filter[keyToSearch] && item.itemName && item.itemName.toLowerCase().indexOf(filter.itemName.toLowerCase()) === -1);
         return !(filter[keyToSearch]  && item[keyToSearch] && item[keyToSearch].toLowerCase().indexOf(filter[keyToSearch].toLowerCase()) === -1);
    }
}


// WEBPACK FOOTER //
// /Users/ldt/Desktop/ARES-admin-frontend/src/app/common/multi/list-filter-pipe.pipe.ts